import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white" style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
            <h1 className="h4 text-uppercase mb-1">FLIGHT OPERATIONS</h1>
            <p className="mb-0">Flight details</p>
        </header>
    </div>
);


// WEBPACK FOOTER //
// ./src/views/flight-operations/view-header.js